"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { FaPaperPlane, FaSearch } from "react-icons/fa";
import "./SearchBox.css";
import useTranslation from "@/hook/useTranslation";

export default function SearchBox({
  locale,
  defaultValue = "",
  onSearch,
  isSearch = false,
}) {
  const router = useRouter();
  const [keyword, setKeyword] = useState(defaultValue);
  const { t } = useTranslation();
  const handleSearch = () => {
    if (keyword.trim()) {
      onSearch?.(keyword);
      if (isSearch) {
        router.push(
          `/${locale}/news?search=${encodeURIComponent(keyword.trim())}`
        );
      }
    }
  };

  return (
    <div className="search-box-wrapper">
      <input
        type="text"
        placeholder={t("newsSearch")}
        className="search-box-input"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
      />
      <button className="search-box-btn" onClick={handleSearch}>
        {isSearch ? <FaSearch /> : <FaPaperPlane />}
      </button>
    </div>
  );
}
